import { BaseButtons, BaseForm, BaseTextInput, useControllerSeServe, useInputGenerico, useRichiestaServer } from '@lucan/base-ui';
import datiListCompleta from 'configuration/list.json';
import React, { useEffect, useState } from "react"
import {
  Box,
  Checkbox,
  FormControlLabel,
  List,
  ListItemButton,
  ListItemText,
  TextField,
  Typography
} from "@mui/material"
import { OPERAZIONI } from 'configuration/ConfigurazioneApi';
import { useAppContext } from 'GlobalContext';
import { DatePicker } from '@mui/lab';

export default function Configurazioni({cmd=null}) {
 const {
    ScatolaMessaggi,
    inviaOperazione,
    inAttesaDelServer
  } = useRichiestaServer()
  const {cmd: cmdContesto} = useAppContext()
  const cmdScelto = cmd || cmdContesto
  const [modules, setModules] = useState(null)
  const scopes = process.env.REACT_APP_ENV_CONFIG_SCOPE.split(',').map(file => file.trim())

  useEffect(() => {
    caricaCampi() 

  }, [])
  


  function nomeCampo(path) {
    return path.split("/").pop().replace(".json", "").replaceAll("_", " ").replace(/(?:^\w|[A-Z]|\b\w)/g, function(word, index) {
    return word.toUpperCase()
  })
  }
  

  //const modules = import.meta.glob("../configuration/**/*.json")

  async function loadConfigFile(path) {
    const key = path

    if (!modules[key]) {
      throw new Error(`File non trovato: ${key}`)
    }

    return modules[key]
  }

  const [defaultData, setDefaultData] = useState(null)
  
  async function loadDefault(chiave, contenuto){
    setDefaultData(null) // utile per resettare il form al cambio di data
    const { ok, data } = await inviaOperazione(OPERAZIONI.CONFIGURAZIONE_NO_LANG_GET, null, {}, { urlParams: { cmd: cmdScelto, chiave, lingua:"" } })
    if (ok) { 
      setDefaultData(data)
    }
  }

  const [ambitoSelezionato, setAmbitoSelezionato] = useState(null)
  const [campoSelezionato, setCampoSelezionato] = useState(null)
  const [contenuto, setContenuto] = useState(null)
  const datiList = datiListCompleta.filter(a => scopes.includes(a.ambito))
  const ambito = datiList.find(a => a.ambito === ambitoSelezionato)

  async function handleCampoClick(path) {
    setCampoSelezionato(path)
    const json = await loadConfigFile(path)
    setContenuto(json)
    loadDefault(path.replace(".json",""), json)
  }

  async function salvaComunicazione(data) {
    const dataToSend = data
    console.log( dataToSend )
    
    const { ok } = await inviaOperazione(OPERAZIONI.CONFIGURAZIONE_SAVE, dataToSend, {}, { urlParams: { cmd: cmdScelto } })
    if (ok ) {
      console.log("salvato con successo")
      handleCampoClick(campoSelezionato)
    }
  
  }
  
  async function caricaCampi() {
    const dataToSend = scopes
    console.log( dataToSend )
    
    const { ok, data } = await inviaOperazione(OPERAZIONI.CONFIGURAZIONE_FIELDS, {lista:dataToSend}, {}, { urlParams: { cmd: cmdScelto } })
    if (ok ) {
      console.log("caricaCampi", data)
      setModules(data)
    }
  
  }

  return (
    <Box display="flex" height="100%">
      {/* LIVELLO 1 */}
      <List sx={{ width: 220, borderRight: "1px solid #ddd" }}>
        {datiList.map(a => (
          <ListItemButton
            key={a.ambito}
            selected={ambitoSelezionato === a.ambito}
            onClick={() => {
              setAmbitoSelezionato(a.ambito)
              setCampoSelezionato(null)
              setContenuto(null)
            }}
          >
            <ListItemText primary={a.ambito} />
          </ListItemButton>
        ))}
      </List>

      {/* LIVELLO 2 */}
      <List sx={{ width: 260, borderRight: "1px solid #ddd" }}>
        {ambito?.campi.map(campo => (
          <ListItemButton
            key={campo}
            selected={campoSelezionato === campo}
            onClick={() => handleCampoClick(campo)}
          >
            <ListItemText primary={nomeCampo(campo)} />
          </ListItemButton>
        ))}
      </List>

      {/* CONTENUTO */}
      <Box p={2} flex={1}>
        {ScatolaMessaggi}
        {contenuto && defaultData !== null ? (
          <>
            <Typography variant="h6">
              {nomeCampo(campoSelezionato)}
            </Typography>
            <BaseForm
              key={campoSelezionato}  
              defaultValues={defaultData}
              onSubmit={salvaComunicazione}
              inAttesa={inAttesaDelServer}
              //inAttesa={inAttesaDelServer}
            >{contenuto.map(p => <JsonTextField key={campoSelezionato+p.name}
                  {...p}
                />)}
             
              <BaseButtons.Salva />
            </BaseForm>

            <pre>{JSON.stringify(defaultData, null, 2)}</pre>
            <pre>{JSON.stringify(contenuto, null, 2)}</pre>
          </>
        ) : (
          <Typography color="text.secondary">
            Seleziona una configurazione
          </Typography>
        )}
      </Box>
    </Box>
  )
}

 function toInputString(value) {
  if (value === undefined || value === null) return ""
  if (typeof value === "string") return value
  return JSON.stringify(value, null, 2)
}

function parseInput(value) {
  if (value === "") return ""

  try {
    return JSON.parse(value)
  } catch {
    return value
  }
}

function JsonTextField(props) {

const {
  label,
  posizioneLabel = 'sopra',
    ...restProps
  } = props
const mappaLabelPlacement = {
  sopra: 'top',
  sotto: 'bottom',
  destra: 'end',
  sinistra: 'start'
}
  const inputGenericoProps = useInputGenerico({
    componenteControllato: true,
    widthType: 'width',
    ...restProps
  })
  const {
    value,
    onBlur,
    onChange,
    ref,
    propsRimanenti
  } = useControllerSeServe(inputGenericoProps)

  function getInputComponent(tipo) {
    const map = {
      string: TextField,
      number: TextField,
      boolean: Checkbox,
      date: DatePicker,
      object: TextField, // multiline + JSON
      array: TextField,  // multiline + JSON
      null: TextField,
      undefined: TextField,
    };
    return map[tipo] || TextField;
  }
  function detectType(value) {
    if (value === null || value === undefined) return "null";
    if (typeof value === "string") return "string";
    if (typeof value === "number") return "number";
    if (typeof value === "boolean") return "boolean";
    if (value instanceof Date) return "date";
    if (Array.isArray(value)) return "array";
    if (typeof value === "object") return "object";
    return "string";
  }
    const tipo = detectType(value);

  const InputElement = (() => {
    switch (tipo) {
      case "boolean":
        return (
          <Checkbox
            checked={value || false}
            onChange={(e) => onChange(parseInput(e.target.checked))}
            onBlur={onBlur}
            /*{...propsRimanenti}  <- da problemi sull'onchange*/
          />
        );

      case "date":
        return (
          <DatePicker
            value={value || null}
            onChange={onChange}
            renderInput={(params) => <TextField {...params} {...propsRimanenti} />}
          />
        );

      case "object":
      case "array":
        return (
          <TextField
            multiline
            minRows={3}
            maxRows={10}
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );

      case "number":
        return (
          <TextField
            type="number"
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );

      case "string":
      case "null":
      default:
        return (
          <TextField
            value={toInputString(value)}
            onChange={(e) => onChange(parseInput(e.target.value))}
            onBlur={onBlur}
            {...propsRimanenti}
          />
        );
    }
  })();
  return (
    <FormControlLabel
      label={label}
      labelPlacement={mappaLabelPlacement[posizioneLabel]}
      value={toInputString(value)}
      onBlur={onBlur}
      onChange={e => {
            const raw = e.target.value
            console.log(raw, parseInput(raw), value)
            onChange(parseInput(raw))
          }}
      control={InputElement}
    />
  )
}